// Раскладка карточки СДЕЛКИ «как в Bitrix» — данные, а не разметка.
//
// ОТКУДА. Порядок разделов и полей снят из DOM боевой карточки Bitrix
// (cp.cir.cx, сделка 112191, 31.07.2026): 14 разделов, поля по порядку.
// Подписи, типы, множественность и варианты списков — из зеркала bx_fields
// (entity='deal'): подпись — raw->>'formLabel' (колонка title у UF-полей
// равна коду и подписью не является), варианты — enum_values.
//
// ЧЕГО ЗДЕСЬ НЕТ. Поле UF_CRM_1748594020 («Чеки») в раскладку не включено:
// в нём ссылки на чеки, открывающиеся без авторизации, а такие данные по
// правилам проекта в CRM не показываются (в DOM Bitrix поле стоит без подписи).
//
// ПСЕВДОПОЛЯ BITRIX. OPPORTUNITY_WITH_CURRENCY и CLIENT — поля интерфейса,
// а не данных: в bx_fields их нет. Первое собирается из OPPORTUNITY +
// CURRENCY_ID, второе — из COMPANY_ID + CONTACT_ID. Карточка разбирает их
// по типам 'money' и 'client'.
//
// Файл СГЕНЕРИРОВАН запросом к bx_fields — руками не дописывать; при смене
// полей в Bitrix перегенерировать тем же способом.

/** Типы полей Bitrix, встречающиеся в раскладке сделки (field_type из bx_fields
 *  + два псевдотипа интерфейса: 'money' и 'client'). */
export type BxFieldType =
  | 'boolean'
  | 'client'
  | 'crm'
  | 'crm_status'
  | 'date'
  | 'datetime'
  | 'double'
  | 'employee'
  | 'enumeration'
  | 'file'
  | 'money'
  | 'string'
  | 'url'
  | 'user'

export interface LayoutEnum { id: string; value: string }

export interface LayoutField {
  /** Код поля Bitrix — ключ значения в raw сделки. */
  code: string
  title: string
  type: BxFieldType
  /** Множественное поле: значение приходит массивом. */
  multiple: boolean
  /** Для enumeration и crm_status: id → подпись. */
  enum?: LayoutEnum[]
}

export interface LayoutSection { title: string; fields: LayoutField[] }

/** 14 разделов карточки сделки — в порядке Bitrix. */
export const DEAL_LAYOUT: LayoutSection[] = [
  {
    title: "🚢 О сделке 🚢",
    fields: [
      { code: "TITLE", title: "Название", type: "string", multiple: false },
      { code: "OPPORTUNITY_WITH_CURRENCY", title: "Сумма и валюта", type: "money", multiple: false },
      { code: "CLIENT", title: "Клиент", type: "client", multiple: false },
      { code: "UF_CRM_1621413940", title: "Реестр договоров", type: "crm", multiple: true },
      { code: "ASSIGNED_BY_ID", title: "Ответственный", type: "user", multiple: false },
      { code: "UF_CRM_1775728858", title: "Ответственный за дебиторку", type: "employee", multiple: false },
      { code: "UF_CRM_1492348361", title: "Заявка", type: "string", multiple: false },
      { code: "UF_CRM_1596536424782", title: "Заявка (файл)", type: "file", multiple: true },
      { code: "UF_CRM_1488224298", title: "Договор", type: "file", multiple: true },
      { code: "UF_CRM_1667905876", title: "Доп работа (комментарий в задачу)", type: "string", multiple: false },
      { code: "UF_CRM_1502613831", title: "Судно", type: "crm", multiple: false },
      { code: "UF_CRM_1499181309", title: "системный код", type: "double", multiple: false },
      { code: "UF_CRM_1623328239", title: "Смежная сделка", type: "crm", multiple: true },
      { code: "UF_CRM_1718280440904", title: "Причина отрицательно закрытой сделки", type: "enumeration", multiple: false,
        enum: [
          { id: "3531", value: "Дубль" },
          { id: "3532", value: "Слишком высокие цены" },
          { id: "3533", value: "Не успеваем по срокам" },
          { id: "3534", value: "Закрыта по тендеру \"Морспас\"" },
          { id: "3707", value: "Не потребовалось / отменили закупку" },
          { id: "3871", value: "Не наш профиль" },
        ] },
      { code: "UF_CRM_1634196387132", title: "Почему сделка была проиграна? / Почему не выставляется?", type: "string", multiple: false },
      { code: "UF_CRM_1769093705480", title: "ТЕХ | Подтверждение отправки по ЭДО", type: "file", multiple: true },
    ],
  },
  {
    title: "💳 СЧЕТА 💳",
    fields: [
      { code: "UF_CRM_1526208799", title: "Наша компания", type: "enumeration", multiple: false,
        enum: [
          { id: "304", value: "НАВИГАЦИЯ СПБ" },
          { id: "306", value: "СиР СПб" },
          { id: "308", value: "НаВ" },
          { id: "1649", value: "СИР ТЕХНОЛОГИИ" },
          { id: "318", value: "СИР" },
          { id: "1707", value: "СИР Архангельск" },
          { id: "3873", value: "СИР РНД" },
          { id: "310", value: "Инвоис (ханза)" },
          { id: "312", value: "Инвоис (турция)" },
          { id: "314", value: "Инвоис (сир)" },
          { id: "562", value: "СиР 2021" },
          { id: "316", value: "СиР 2020" },
          { id: "959", value: "СИР СПБ ENG" },
          { id: "1077", value: "Инвойс (НаВ)" },
          { id: "969", value: "ESMA COM (не использовать)" },
          { id: "1035", value: "Б/Н" },
          { id: "3702", value: "Fluda (не использовать)" },
          { id: "3802", value: "ООО \"СИМЕТ\"" },
          { id: "4744", value: "ЭРС" },
          { id: "5339", value: "СиР Снаб" },
        ] },
      { code: "UF_CRM_1752149510", title: "Дата оплаты", type: "date", multiple: false },
      { code: "UF_CRM_1556950714", title: "Примерная дата оплаты", type: "datetime", multiple: false },
      { code: "UF_CRM_1492363130", title: "Доставочный лист", type: "file", multiple: true },
      { code: "UF_CRM_1496935825", title: "Счет продажа (файл)1", type: "file", multiple: true },
      { code: "UF_CRM_1535731387", title: "Закрывающие документы файлы", type: "file", multiple: true },
      { code: "UF_CRM_UPDBEZPE4ATI", title: "УПД без печати", type: "file", multiple: true },
      { code: "UF_CRM_1683900163", title: "Техническое поле Сумма поступления оплаты", type: "double", multiple: false },
      { code: "UF_CRM_1486929911", title: "Счет продажа", type: "string", multiple: false },
      { code: "UF_CRM_1754318376", title: "Номер УПД", type: "double", multiple: false },
      { code: "UF_CRM_1754318347", title: "Сумма по УПД", type: "double", multiple: false },
      { code: "UF_CRM_1487506483", title: "Оплачен", type: "date", multiple: false },
    ],
  },
  {
    title: "🧮 расчеты 🧮",
    fields: [
      { code: "TYPE_ID", title: "Тип", type: "crm_status", multiple: false,
        enum: [
          { id: "UC_EKCVAB", value: "Не выбрано" },
          { id: "UC_VNOV43", value: "Продажа с установкой" },
          { id: "1", value: "Eng" },
          { id: "2", value: "Тендер" },
          { id: "4", value: "-" },
          { id: "GOODS", value: "Продажа товара" },
          { id: "SERVICES", value: "Сервис" },
          { id: "UC_0A7CXE", value: "Ремонт (НЕ ИСПОЛЬЗОВАТЬ)" },
          { id: "3", value: "СЗЧ (НЕ ИСПОЛЬЗОВАТЬ)" },
          { id: "UC_WEBQR0", value: "Комплексная ОС (НЕ ИСПОЛЬЗОВАТЬ)" },
          { id: "UC_7P1UMJ", value: "Комплексная Общая (НЕ ИСПОЛЬЗОВАТЬ)" },
          { id: "SALE", value: "Комплексная продажа (НЕ ИСПОЛЬЗОВАТЬ)" },
          { id: "UC_2VQTXM", value: "Гарантия" },
          { id: "UC_3U069K", value: "Яхты" },
          { id: "UC_J78RUM", value: "ИСУ-ТС" },
          { id: "UC_8361BX", value: "Холодная продажа (ОС)" },
        ] },
      { code: "UF_CRM_1705496987", title: "Категории товаров", type: "enumeration", multiple: true,
        enum: [
          { id: "3138", value: "ПВ/КВ" },
          { id: "3139", value: "Стационарные станции УКВ" },
          { id: "3140", value: "Навтекс" },
          { id: "3141", value: "Внутрисудовые системы связи (комплект)" },
          { id: "3142", value: "Гирокомпас" },
          { id: "3143", value: "Компас Магнитный" },
          { id: "3144", value: "ГНСС" },
          { id: "3145", value: "РЛС" },
          { id: "3146", value: "РДР" },
          { id: "3147", value: "АИС" },
          { id: "3148", value: "Спутниковый компас" },
          { id: "3149", value: "Лаг" },
          { id: "3150", value: "Эхолот" },
          { id: "3151", value: "ЭКНИС" },
          { id: "3152", value: "Инмарсат" },
          { id: "3891", value: "Спутниковые системы связи (VSAT/FBB/IRIDIUM)" },
          { id: "3892", value: "Рыбопромысловые системы (эхолоты, сонары, системы контроля трала)" },
          { id: "3886", value: "Веном" },
          { id: "3153", value: "ИНОЕ" },
          { id: "3171", value: "Сервис" },
          { id: "4579", value: "Автоматика" },
          { id: "4649", value: "ИСУ-ТС" },
          { id: "4712", value: "Механика" },
          { id: "4825", value: "Сварочные работы" },
        ] },
      { code: "UF_CRM_1570972880", title: "Принадлежность к подразделению", type: "enumeration", multiple: false,
        enum: [
          { id: "787", value: "Санкт-Петербург" },
          { id: "789", value: "Ростов-На-Дону" },
          { id: "791", value: "Владивосток" },
          { id: "793", value: "Мурманск" },
          { id: "795", value: "Калининград" },
          { id: "1041", value: "Новороссийск" },
          { id: "1089", value: "Астрахань" },
          { id: "1179", value: "Южно-Сахалинск" },
          { id: "1181", value: "Автоматика" },
          { id: "1207", value: "Сторонние" },
          { id: "1509", value: "Архангельск (не использовать)" },
          { id: "2145", value: "Архангельск (СиР)" },
          { id: "2776", value: "РнД Автоматика" },
          { id: "3667", value: "РнД Сварочный участок" },
          { id: "3135", value: "Металлоконструкции" },
          { id: "3297", value: "Спутниковый отдел" },
          { id: "3663", value: "Рыбопромысел" },
          { id: "2774", value: "Отдел ремонта (СПб)" },
          { id: "4150", value: "Автоматика Астрахань" },
          { id: "4151", value: "Автоматика Новороссийск" },
          { id: "4156", value: "Автоматика Мурманск" },
          { id: "4906", value: "Автоматика ДВ" },
          { id: "4927", value: "Радио Темрюк" },
          { id: "4928", value: "Автоматика Темрюк" },
          { id: "5145", value: "РнД Механика" },
          { id: "5567", value: "СИР Снаб" },
          { id: "5599", value: "Мурманск Рыбопромысел" },
          { id: "5600", value: "Калининград Рыбопромысел" },
          { id: "5601", value: "Владивосток Рыбопромысел" },
        ] },
      { code: "UF_CRM_1578299596", title: "Отчетный месяц", type: "enumeration", multiple: false,
        enum: [
          { id: "871", value: "январь" },
          { id: "873", value: "февраль" },
          { id: "875", value: "март" },
          { id: "877", value: "апрель" },
          { id: "879", value: "май" },
          { id: "881", value: "июнь" },
          { id: "883", value: "июль" },
          { id: "885", value: "август" },
          { id: "887", value: "сентябрь" },
          { id: "889", value: "октябрь" },
          { id: "891", value: "ноябрь" },
          { id: "893", value: "декабрь" },
        ] },
      { code: "UF_CRM_1578299654", title: "Отчетный год", type: "enumeration", multiple: false,
        enum: [
          { id: "895", value: "2019" },
          { id: "897", value: "2020" },
          { id: "1025", value: "2021" },
          { id: "1237", value: "2022" },
          { id: "2055", value: "2023" },
          { id: "3132", value: "2024" },
          { id: "4091", value: "2025" },
          { id: "4904", value: "2026" },
        ] },
      { code: "UF_CRM_1732879618", title: "Налог для расчетов", type: "enumeration", multiple: false,
        enum: [
          { id: "3902", value: "УСН 6% (СПБ, РНД)" },
          { id: "3903", value: "Товар с НДС 20% (25% на прибыль), услуги УСН 6% (СПБ)" },
          { id: "3904", value: "Казахи (25% на прибыль)" },
          { id: "3905", value: "Без НДС (25% на прибыль) (СПБ ин)" },
          { id: "3906", value: "Товар с НДС 20%, услуги без НДС, (25% на прибыль) (СПБ)" },
          { id: "3907", value: "Все с НДС 20%, 5% на прибыль (СИР ТЕХ)" },
          { id: "3908", value: "Все с НДС 20% (25% на прибыль), услуги закуп УСН (СПБ)" },
          { id: "3909", value: "НаВ 5% НДС, 7% на прибыль" },
          { id: "4090", value: "CandR Side 2%" },
          { id: "4099", value: "Все УСН 11% (СИР ПТЗ)" },
          { id: "4100", value: "Все УСН 1% (Арх)" },
          { id: "4101", value: "КМ 4%" },
          { id: "4102", value: "Инв." },
          { id: "4889", value: "Все с НДС 20% (25% на прибыль)" },
          { id: "4891", value: "5% на прибыль (Реестр ПО)" },
          { id: "4910", value: "Товар с НДС 22% (25% на прибыль), услуги УСН 6% (СПБ)" },
          { id: "4911", value: "Товар с НДС 22%, услуги без НДС, (25% на прибыль) (СПБ)" },
          { id: "4912", value: "Все с НДС 22%, 5% на прибыль (СИР ТЕХ)" },
          { id: "4913", value: "Все с НДС 22% (25% на прибыль), услуги закуп УСН (СПБ)" },
          { id: "4914", value: "Все с НДС 22% (25% на прибыль)" },
          { id: "4935", value: "Переходная ставка НДС 22/20% услуги 6%" },
          { id: "5341", value: "СиР Снаб 15% на прибыль" },
          { id: "5561", value: "СиР РнД 5% НДС, 6% на прибыль" },
        ] },
      { code: "UF_CRM_1513747336", title: "Налоги", type: "double", multiple: false },
      { code: "UF_CRM_1486892924", title: "Разница", type: "double", multiple: false },
      { code: "UF_CRM_1646893434", title: "Разница Сервис", type: "double", multiple: false },
      { code: "UF_CRM_1487516105", title: "Затраты", type: "double", multiple: false },
      { code: "UF_CRM_1656412208", title: "Второе подразделение", type: "enumeration", multiple: false,
        enum: [
          { id: "1609", value: "Санкт-Петербург" },
          { id: "1611", value: "Ростов-На-Дону" },
          { id: "1613", value: "Владивосток" },
          { id: "1615", value: "Мурманск" },
          { id: "1617", value: "Калининград" },
          { id: "1619", value: "Новороссийск" },
          { id: "1621", value: "Астрахань" },
          { id: "1623", value: "Южно-Сахалинск" },
          { id: "1625", value: "Автоматика" },
          { id: "1627", value: "Архангельск (Арх.)" },
          { id: "2144", value: "Архангельск (СиР)" },
          { id: "2778", value: "РнД Автоматика" },
          { id: "3189", value: "Металлоконструкции" },
          { id: "3299", value: "Спутниковый отдел" },
          { id: "3653", value: "РнД Сварочный участок" },
          { id: "3661", value: "Рыбопромысел" },
          { id: "4622", value: "Автоматика Мурманск" },
          { id: "4740", value: "Автоматика Астрахань" },
          { id: "4741", value: "Автоматика Новороссийск" },
          { id: "4908", value: "Автоматика ДВ" },
          { id: "4932", value: "Радио Темрюк" },
          { id: "4931", value: "Автоматика Темрюк" },
          { id: "5147", value: "РнД Механика" },
          { id: "5605", value: "Мурманск Рыбопромысел" },
          { id: "5606", value: "Калининград Рыбопромысел" },
          { id: "5607", value: "Владивосток Рыбопромысел" },
          { id: "5622", value: "Отдел разработки навигационного оборудования" },
        ] },
      { code: "UF_CRM_1656412107", title: "Прибыль второго подразделения", type: "double", multiple: false },
      { code: "UF_CRM_1723791743603", title: "Размер инфляции (Обратная если минус)", type: "double", multiple: false },
      { code: "UF_CRM_1673269021", title: "Доля закупщика", type: "double", multiple: false },
      { code: "UF_CRM_1536305410", title: "Процент прибыли", type: "double", multiple: false },
      { code: "CLOSEDATE", title: "Дата завершения", type: "date", multiple: false },
    ],
  },
  {
    title: "⭐️ТЕ самые⭐️",
    fields: [
      { code: "UF_CRM_1662045265287", title: "Себестоимость: То самое поле ОП", type: "double", multiple: false },
      { code: "UF_CRM_1707292296", title: "Себестоимость: То самое поле ОС", type: "double", multiple: false },
      { code: "UF_CRM_1709189157", title: "Пропорциональная себестоимость: Те самые расходы", type: "double", multiple: false },
      { code: "UF_CRM_1739952119407", title: "Себестоимость: то самое поле проект", type: "double", multiple: false },
      { code: "UF_CRM_1770041683", title: "Клиент (те самые)", type: "crm", multiple: false },
      { code: "UF_CRM_1770280410", title: "Клиент 2 (те самые)", type: "crm", multiple: false },
      { code: "UF_CRM_1770280468", title: "Сумма первому клиенту (те самые)", type: "string", multiple: false },
      { code: "UF_CRM_1770280515", title: "Сумма второму клиенту (те самые)", type: "string", multiple: false },
      { code: "UF_CRM_1773319405", title: "Те самые сделки123", type: "crm", multiple: true },
    ],
  },
  {
    title: "💰ОП💰",
    fields: [
      { code: "UF_CRM_1634296456", title: "Ответственный Менеджер ОП", type: "employee", multiple: false },
      { code: "UF_CRM_1646893406", title: "Разница ОП", type: "double", multiple: false },
      { code: "UF_CRM_1487506273", title: "◙ Выставляемая стоимость товара (РУБ)◙", type: "double", multiple: false },
      { code: "UF_CRM_1486929922", title: "▲ Себестоимость товара (РУБ) ▲", type: "string", multiple: false },
      { code: "UF_CRM_1488002280", title: "◙ Выставляемая стоимость доставки (РУБ) ◙", type: "double", multiple: false },
      { code: "UF_CRM_1487507142", title: "▲ Себестоимость доставки (РУБ) ▲", type: "double", multiple: false },
      { code: "UF_CRM_1673268999", title: "Налог Расходники", type: "enumeration", multiple: false,
        enum: [
          { id: "2120", value: "Как в сделке" },
          { id: "2121", value: "20%" },
          { id: "4093", value: "11%" },
          { id: "4920", value: "22%" },
        ] },
      { code: "UF_CRM_1673268959", title: "◙ Выставляемая стоимость Расходники (РУБ) ◙", type: "double", multiple: false },
      { code: "UF_CRM_1673268976", title: "▲ Себестоимость Расходники (РУБ) ▲", type: "double", multiple: false },
      { code: "UF_CRM_1650976227", title: "▲ Себестоимость инженеров (РУБ) ▲", type: "double", multiple: false },
      { code: "UF_CRM_1708327318912", title: "Регион продаж", type: "enumeration", multiple: false,
        enum: [
          { id: "3199", value: "СПБ" },
          { id: "3200", value: "РнД" },
          { id: "3201", value: "ДВ" },
          { id: "3202", value: "Мурманск" },
          { id: "3205", value: "Калининград" },
          { id: "3203", value: "Новороссийск" },
          { id: "3204", value: "Астрахань" },
          { id: "3206", value: "Южно-Сахалинск" },
          { id: "3207", value: "Автоматика" },
          { id: "3208", value: "Архангельск" },
        ] },
      { code: "UF_CRM_1666764844", title: "Процент инициативы (ОС)", type: "double", multiple: false },
      { code: "UF_CRM_1666764799", title: "Процент инициативы (ОП)", type: "double", multiple: false },
      { code: "UF_CRM_1666773684", title: "Сверхприбыль Товар (РУБ)", type: "double", multiple: false },
      { code: "UF_CRM_1776688104", title: "Второй ответственный менеджер ОП", type: "employee", multiple: false },
      { code: "UF_CRM_1776688369329", title: "Процентное соотношение прибыли ОП", type: "enumeration", multiple: false,
        enum: [
          { id: "5393", value: "50% - 50%" },
          { id: "5394", value: "80% - 20%" },
        ] },
      { code: "UF_CRM_1776688703483", title: "Прибыль второго ОП", type: "double", multiple: false },
    ],
  },
  {
    title: "🗿 лид 🗿",
    fields: [
      { code: "UF_CRM_1673269087", title: "Лидогенератор", type: "employee", multiple: false },
      { code: "UF_CRM_1749476848599", title: "Подразделение лидогенератора", type: "enumeration", multiple: false,
        enum: [
          { id: "4583", value: "Санкт-Петербург" },
          { id: "4584", value: "Ростов-на-Дону" },
          { id: "4585", value: "Владивосток" },
          { id: "4586", value: "Мурманск" },
          { id: "4587", value: "Калининград" },
          { id: "4588", value: "Новороссийск" },
          { id: "4589", value: "Астрахань" },
          { id: "4590", value: "Южно-Сахалинск" },
          { id: "4591", value: "Автоматика" },
          { id: "4592", value: "Сторонние" },
          { id: "4593", value: "Архангельск" },
          { id: "4594", value: "Сварочный участок РнД" },
          { id: "4595", value: "Автоматика РнД" },
          { id: "4596", value: "Металлоконструкции" },
          { id: "4597", value: "Спутниковый отдел" },
          { id: "4598", value: "Рыбопромысел" },
          { id: "4599", value: "Отдел ремонта (СПб)" },
          { id: "4600", value: "Автоматика Астрахань" },
          { id: "4601", value: "Автоматика Новороссийск" },
          { id: "4602", value: "Автоматика Мурманск" },
          { id: "4647", value: "ОП №1" },
          { id: "5611", value: "Владивосток Рыбопромысел" },
          { id: "5612", value: "Калининград Рыбопромысел" },
          { id: "5613", value: "Мурманск Рыбопромысел" },
        ] },
      { code: "UF_CRM_1749476402400", title: "% Лида на сервис", type: "enumeration", multiple: false,
        enum: [
          { id: "4646", value: "10%" },
          { id: "4581", value: "20%" },
          { id: "4582", value: "30%" },
          { id: "4813", value: "40%" },
          { id: "4814", value: "50%" },
        ] },
      { code: "UF_CRM_1749476587413", title: "Сумма лида сервиса", type: "double", multiple: false },
      { code: "UF_CRM_1751371992063", title: "Прибыль лида от Сервиса на ОП", type: "double", multiple: false },
    ],
  },
  {
    title: "🔧 СЕРВИС🔧",
    fields: [
      { code: "UF_CRM_1645012692", title: "Ответственный Координатор", type: "employee", multiple: false },
      { code: "UF_CRM_1752068678", title: "Координатор второго подразделения", type: "employee", multiple: false },
      { code: "UF_CRM_1487506211", title: "◙ Выставляемая стоимость работ (РУБ) ◙", type: "double", multiple: false },
      { code: "UF_CRM_1486929932", title: "▲ Себестоимость работ(РУБ) ▲", type: "string", multiple: false },
      { code: "UF_CRM_1487506235", title: "◙ Выставляемые накладные расходы Сервис (РУБ) ◙", type: "double", multiple: false },
      { code: "UF_CRM_1486932199", title: "▲ Себестоимость накладных Сервиса (РУБ) ▲", type: "double", multiple: false },
      { code: "UF_CRM_1673268855", title: "◙ Выставляемая стоимость Продукты сервиса (РУБ) ◙", type: "double", multiple: false },
      { code: "UF_CRM_1673268896", title: "▲ Себестоимость Продукты сервиса (РУБ) ▲", type: "double", multiple: false },
      { code: "UF_CRM_1664796106", title: "◙ Выставляемая стоимость СЗЧ б/у (РУБ) ◙", type: "double", multiple: false },
      { code: "UF_CRM_1664796140", title: "▲ Себестоимость СЗЧ б/у (РУБ) ▲", type: "double", multiple: false },
      { code: "UF_CRM_1728026480", title: "Надбавленный налог на закупку СЗЧ бу", type: "double", multiple: false },
      { code: "UF_CRM_1690969872", title: "Налог СЗЧ б/у", type: "enumeration", multiple: false,
        enum: [
          { id: "2781", value: "Как в сделке" },
          { id: "2782", value: "20%" },
          { id: "4095", value: "11%" },
          { id: "4922", value: "22%" },
        ] },
      { code: "UF_CRM_1673343636", title: "Закупщик", type: "enumeration", multiple: false,
        enum: [
          { id: "2122", value: "СПб КС" },
          { id: "2123", value: "СПб ОС" },
          { id: "2124", value: "РнД" },
          { id: "2125", value: "Мурманск" },
          { id: "2126", value: "Калининград" },
          { id: "2127", value: "Новороссийск" },
          { id: "2128", value: "Астрахань" },
          { id: "2129", value: "Владивосток" },
          { id: "2130", value: "Автоматика" },
          { id: "2131", value: "Сахалин" },
          { id: "2198", value: "Архангельск" },
        ] },
      { code: "UF_CRM_1685012259", title: "Регион производитель", type: "enumeration", multiple: false,
        enum: [
          { id: "2666", value: "Санкт-Петербург" },
          { id: "2667", value: "Ростов-на-Дону" },
          { id: "2668", value: "Владивосток" },
          { id: "2669", value: "Мурманск" },
          { id: "2670", value: "Калининград" },
          { id: "2671", value: "Новороссийск" },
          { id: "2672", value: "Астрахань" },
          { id: "2673", value: "Южно-Сахалинск" },
          { id: "2674", value: "Автоматика" },
          { id: "2675", value: "Архангельск" },
        ] },
      { code: "UF_CRM_1666773716", title: "Сверхприбыль Сервис (РУБ)", type: "double", multiple: false },
      { code: "UF_CRM_1644419782", title: "◙ Выставляемый НДС ◙", type: "double", multiple: false },
      { code: "UF_CRM_1776937296", title: "Трудозатраты", type: "double", multiple: false },
    ],
  },
  {
    title: "⚙️инженер ⚙️",
    fields: [
      { code: "UF_CRM_5AD48B99950CD", title: "Наш исполнитель", type: "employee", multiple: true },
      { code: "UF_CRM_1485273063", title: "Место стоянки", type: "string", multiple: false },
      { code: "UF_CRM_1724655215", title: "Инженеры техподдержки", type: "employee", multiple: true },
      { code: "UF_CRM_1563429831", title: "Старший инженер", type: "employee", multiple: false },
      { code: "UF_CRM_1739268557", title: "Инженер инициатор", type: "employee", multiple: true },
      { code: "UF_CRM_1730380408840", title: "Инициатива инженера", type: "string", multiple: false },
      { code: "UF_CRM_1741278974763", title: "Дата инициативы", type: "date", multiple: false },
      { code: "UF_CRM_1492350544", title: "ETA", type: "date", multiple: false },
      { code: "UF_CRM_1492362418", title: "ETD", type: "date", multiple: false },
      { code: "UF_CRM_1492360444", title: "Сторонний исполнитель", type: "crm", multiple: true },
    ],
  },
  {
    title: "📑 авр 📑",
    fields: [
      { code: "UF_CRM_1492363244", title: "АВР файл", type: "file", multiple: true },
      { code: "UF_CRM_1709563260", title: "Дата акта (смарт процесс авр)", type: "date", multiple: false },
      { code: "UF_CRM_1485273110", title: "АВР", type: "string", multiple: false },
      { code: "UF_CRM_1625645409194", title: "Субъективная оценка выполненных работ", type: "double", multiple: false },
    ],
  },
  {
    title: "🚚ОТГРУЗКА 🚚",
    fields: [
      { code: "UF_CRM_1487506501", title: "Отгружен", type: "date", multiple: false },
      { code: "UF_CRM_1764327029", title: "Отгружен по складу", type: "date", multiple: false },
      { code: "UF_CRM_1501831516", title: "Номер накладной", type: "string", multiple: false },
      { code: "UF_CRM_1616399477", title: "Номер Мой склад", type: "string", multiple: false },
      { code: "UF_CRM_1489006817", title: "Фото отгрузка", type: "file", multiple: true },
      { code: "UF_CRM_1622624248971", title: "Оборудование для отгрузки (что отгружается?)", type: "string", multiple: false },
      { code: "UF_CRM_1489006478", title: "Ответственный за отгрузку", type: "employee", multiple: false },
      { code: "UF_CRM_5AD48B995482C", title: "Метод отгрузки", type: "enumeration", multiple: false,
        enum: [
          { id: "270", value: "Отгрузка со склада в СПб" },
          { id: "272", value: "ГТП" },
          { id: "274", value: "DIMEX" },
          { id: "276", value: "Деловые линии" },
          { id: "278", value: "СДЭК" },
          { id: "280", value: "Major" },
          { id: "282", value: "EMS" },
          { id: "284", value: "Pony express" },
          { id: "286", value: "Желдорэкспедиция" },
          { id: "288", value: "DHL" },
          { id: "290", value: "TNT" },
          { id: "292", value: "Курьер сервис экспресс" },
          { id: "294", value: "SPSR" },
          { id: "296", value: "DPD" },
          { id: "298", value: "ПЭК" },
          { id: "300", value: "иное" },
          { id: "302", value: "express.ru" },
          { id: "727", value: "Склад РнД" },
        ] },
      { code: "UF_CRM_1531835304", title: "Что отгружается", type: "string", multiple: false },
      { code: "UF_CRM_1531835326", title: "Куда отгружается", type: "string", multiple: false },
      { code: "UF_CRM_1531837294", title: "код отгрузка", type: "double", multiple: false },
    ],
  },
  {
    title: "🛠 РЕМОНТ 🛠",
    fields: [
      { code: "UF_CRM_1693400502795", title: "Инициатор ремонта", type: "enumeration", multiple: false,
        enum: [
          { id: "2820", value: "ОП СПб" },
          { id: "2821", value: "Первое подразделение" },
          { id: "2822", value: "Второе подразделение" },
        ] },
      { code: "UF_CRM_1692785507427", title: "РЕМОНТ (подразделение)", type: "enumeration", multiple: false,
        enum: [
          { id: "2795", value: "Санкт-Петербург" },
          { id: "2796", value: "Ростов-на-Дону" },
          { id: "2797", value: "Владивосток" },
          { id: "3301", value: "Новороссийск" },
          { id: "3683", value: "Астрахань" },
          { id: "3684", value: "Архангельск" },
          { id: "3685", value: "Мурманск" },
          { id: "3686", value: "Калининград" },
        ] },
      { code: "UF_CRM_1692785449618", title: "Прибыль отдела ремонта", type: "double", multiple: false },
      { code: "UF_CRM_1693399848116", title: "Выставляемая стоимость ремонта", type: "double", multiple: false },
      { code: "UF_CRM_1693399885483", title: "Затраты на ремонт (РУБ)", type: "double", multiple: false },
      { code: "UF_CRM_1693400615852", title: "Сверхприбыль Ремонт (РУБЛИ)", type: "double", multiple: false },
    ],
  },
  {
    title: "🏗 проект 🏗",
    fields: [
      { code: "UF_CRM_1726220809", title: "Проектант", type: "employee", multiple: true },
      { code: "UF_CRM_1696499442", title: "Налог Проект", type: "enumeration", multiple: false,
        enum: [
          { id: "3086", value: "20%" },
          { id: "3087", value: "Как в сделке" },
          { id: "4097", value: "11%" },
          { id: "4924", value: "22%" },
        ] },
      { code: "UF_CRM_1662045217770", title: "◙ Выставляемая стоимость проекта / Проект (РУБ) ◙", type: "double", multiple: false },
      { code: "UF_CRM_1662045383217", title: "▲ Себестоимость проекта /Только проект (РУБ) ▲", type: "double", multiple: false },
      { code: "UF_CRM_1679991876", title: "Прибыль проектного отдела", type: "double", multiple: false },
      { code: "UF_CRM_1530800721", title: "Проектант (расходы)", type: "double", multiple: false },
      { code: "UF_CRM_1756882380", title: "Дополнительные расходы проектного отдела", type: "double", multiple: false },
      { code: "UF_CRM_63A2CD64DF7C4", title: "Файл заявки на проект", type: "file", multiple: true },
      { code: "UF_CRM_1728630738834", title: "Ссылка на задачу по проекту", type: "url", multiple: false },
      { code: "UF_CRM_1751900105583", title: "Старая сделка? ", type: "enumeration", multiple: false,
        enum: [
          { id: "4659", value: "да" },
          { id: "4660", value: "нет" },
        ] },
      { code: "UF_CRM_1770732357", title: "Одобренный файл проекта", type: "file", multiple: true },
      { code: "UF_CRM_1765884870", title: "Отчетный период Проектного отдела", type: "date", multiple: true },
    ],
  },
  {
    title: "🚀БЫСТРЫЕ ДЕЙСТВИЯ🚀",
    fields: [
      { code: "UF_CRM_1493037769", title: "Заявка на проект", type: "boolean", multiple: false },
      { code: "UF_CRM_1674629772", title: "Получить отчет по расчету прибыли по этой сделке", type: "boolean", multiple: false },
      { code: "UF_CRM_1563189486", title: "Передать в отдел ремонта", type: "boolean", multiple: false },
      { code: "UF_CRM_1633618452", title: "Проценка сервис", type: "boolean", multiple: false },
      { code: "UF_CRM_1674471672", title: "Проценка СЗЧ", type: "boolean", multiple: false },
      { code: "UF_CRM_1637572887", title: "Повторное письмо клиенту со Счетом и АВРом", type: "boolean", multiple: false },
      { code: "UF_CRM_1611323085", title: "Оферта СиР СПб", type: "boolean", multiple: false },
      { code: "UF_CRM_1612191612", title: "Оферта НАВИ СПб", type: "boolean", multiple: false },
      { code: "UF_CRM_1613139073125", title: "Оферта СиР ПТЗ", type: "boolean", multiple: false },
      { code: "UF_CRM_1614958223813", title: "Оферта НаВ", type: "boolean", multiple: false },
      { code: "UF_CRM_1562579629", title: "Отгрузка оборудования (ЗИП) в другой город", type: "boolean", multiple: false },
      { code: "UF_CRM_1636988363149", title: "Сообщение Клиенту об отправке Инженеров на судно", type: "boolean", multiple: false },
      { code: "UF_CRM_1678135586", title: "Запрос детального технического заключения по заявке от Техподдержки", type: "boolean", multiple: false },
      { code: "UF_CRM_1676384281", title: "Запустить БП Короткая верификация", type: "boolean", multiple: false },
      { code: "UF_CRM_1717577910093", title: "Заполнить рыбную верификацию", type: "boolean", multiple: false },
      { code: "UF_CRM_1659449958", title: "Заполнить Полную верификацию радиооборудования", type: "boolean", multiple: false },
      { code: "UF_CRM_1665646039", title: "Заполнить Полную верификацию навигационного оборудования", type: "boolean", multiple: false },
    ],
  },
  {
    title: "🗃 Прочие условия 🗃",
    fields: [
      { code: "UF_CRM_5AD48B9A3A9E7", title: "Прочие условия", type: "string", multiple: false },
      { code: "UF_CRM_1534094702", title: "ЕСЛИ ЕСТЬ РАБОТЫ СКОПИРУЙ ДАННЫЙ ТЕКСТ В ПРОЧИЕ УСЛОВИЯ", type: "string", multiple: false },
      { code: "UF_CRM_5AD48B9A022BA", title: "Условия оплаты", type: "string", multiple: false },
      { code: "UF_CRM_5AD48B9A1FA12", title: "Условия поставки", type: "string", multiple: false },
    ],
  },
]
